import { render, staticRenderFns } from "./DurationSelector.vue?vue&type=template&id=478fd22f&"
import script from "./DurationSelector.vue?vue&type=script&lang=js&"
export * from "./DurationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports